import React from "react";
import { ProjectList } from "@swegon/sds-core";

import "./Home.css";

const Home = () => {
    return (
        <section id='home'>
            <div id='Projects' className='Widget'>
                <ProjectList />
            </div>

            {/* TODO: Add the news widget here */}
        </section>
    );
};
export default Home;
